<template>
  <el-card shadow="never"
    ><el-page-header @back="goBack" :content="componentName"> </el-page-header>
    <el-divider></el-divider>
    <!-- 表单 -->
    <el-form ref="formNewCourse" :model="formNewCourse" label-width="80px">
      <!-- 课程名称 -->
      <el-form-item label="名称">
        <el-input
          style="width: 20%"
          size="mini"
          v-model="formNewCourse.section_name"
        ></el-input>
      </el-form-item>
      <!-- 章节 -->
      <el-form-item label="章节">
        <el-autocomplete
          :clearable="true"
          class="inline-input"
          style="width: 20%"
          :fetch-suggestions="querySearch"
          @select="handleSelect"
          size="mini"
          v-model="formNewCourse.capter_name"
        ></el-autocomplete>
        <el-link
          style="margin-left: 20px"
          :underline="false"
          @click="addChapter"
          >添加章节</el-link
        >
      </el-form-item>
      <!-- 课程作者 -->
      <el-form-item label="作者">
        <el-input
          style="width: 20%"
          size="mini"
          v-model="formNewCourse.author"
        ></el-input>
      </el-form-item>
      <!-- 封面 -->
      <el-form-item label="封面">
        <up-load @getImageURl="getImageURl"></up-load>
      </el-form-item>
      <!-- 简介 -->
      <el-form-item label="简介">
        <el-input
          style="width: 40%"
          type="textarea"
          v-model="formNewCourse.section_info"
        ></el-input>
      </el-form-item>
      <!-- 内容 -->

      <el-form-item label="内容">
        <div style="width: 94%">
          <traver-editor
            :stickToolbar="652"
            @content_change="content_change"
            :editor_content="formNewCourse.section_content"
          ></traver-editor>
        </div>
      </el-form-item>
      <!-- 提交表单 -->
      <el-form-item>
        <el-button size="mini" type="primary" @click="onSubmitNewSection"
          >立即创建</el-button
        >
        <el-button size="mini">取消</el-button>
      </el-form-item>
    </el-form>

    <!----------- 选择章节的对话框 ------------->
    <el-dialog
      :title="course_name"
      :visible.sync="dialogSelectChapter"
      width="30%"
    >
      <el-input
        size="mini"
        v-model="chapterName"
        placeholder="请输入内容"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSelectChapter = false">取 消</el-button>
        <el-button type="primary" @click="submitNewChapter">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import UpLoad from "../../components/common/other/UpLoad";
import { tpx_app } from "../../network/request";
import Editor from "../../components/common/editor/editorV2";
export default {
  name: "creat-new-section",
  components: {
    "up-load": UpLoad,
    "traver-editor": Editor,
  },
  data() {
    return {
      course_id: "",
      course_name: "",
      componentName: "添加课程内容",
      dialogSelectChapter: false,

      chapterName: "", // 章节名称
      chapterNameList: "", // 全部章名称
      formNewCourse: {
        editor_content: "", //编辑器内容
      },
    };
  },
  mounted() {
    this.course_id = this.$route.params.course_id;
    if (this.$route.params.course_id) {
      // 获取课程信息
      tpx_app({
        url: "/get_all_course",
        data: {
          course_id: this.$route.params.course_id,
        },
      }).then((res) => {
        this.course_name = res.data.data[0].course_name;
        // 获取章节信息
        this.getAllChapter(res.data.data[0].course_id);
      });
    } else {
      this.$router.push({
        name: "course_content_manage",
        params: {
          course_id: this.course_id,
        },
      });
    }
  },
  methods: {
    //  提交新的节内容
    onSubmitNewSection() {
      tpx_app({
        url: "add_course_section",
        method: "POST",
        data: this.formNewCourse,
      }).then((res) => {
        const { errno, errmsg } = res.data;
        if (errno == "0") {
          this.$notify({
            title: "成功",
            message: errmsg,
            type: "success",
          });
          this.$router.push({
            name: "course_content_manage",
            params: {
              course_id: this.course_id,
            },
          });
          this.formNewCourse = {};
        } else {
          this.$notify.error({
            title: "错误",
            message: errmsg,
          });
        }
      });
    },
    //   上一页
    goBack() {
      this.$router.push({
        name: "course_content_manage",
        params: {
          course_id: this.course_id,
        },
      });
    },
    // 新增章节对话框
    addChapter() {
      this.dialogSelectChapter = true;
    },
    // handleSelect
    handleSelect(item) {
      this.formNewCourse.chapter_id = item.id;
    },
    // 提交新章节名
    submitNewChapter() {
      tpx_app({
        url: "add_course_chapter",
        params: {
          course_id: this.course_id,
          chapter_name: this.chapterName,
        },
      }).then((res) => {
        const { errno, errmsg } = res.data;
        if (errno == "0") {
          this.$notify({
            title: "成功",
            message: errmsg,
            type: "success",
          });
          this.dialogSelectChapter = false;
          this.chapterName = "";
        } else {
          this.$notify.error({
            title: "错误",
            message: errmsg,
          });
        }
      });
    },
    // 获取章 名称列表
    getAllChapter(course_id) {
      tpx_app({
        url: "get_course_chapter",
        params: {
          course_id: course_id,
        },
      }).then((res) => {
        const { errno, errmsg, data } = res.data;
        if (errno == "0") {
          this.chapterNameList = data;
        }
      });
    },

    getImageURl(value) {
      this.formNewCourse.section_cover = value;
    },
    content_change(content) {
      this.formNewCourse.section_content = content;
    },
    // 自动匹配章
    querySearch(queryString, cb) {
      let chapters = this.chapterNameList;
      let results = queryString
        ? chapters.filter(this.createFilter(queryString))
        : chapters;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      console.log("sss");
      return (chapters) => {
        return (
          chapters.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
  },
};
</script>

<style>
.ql-editor {
  /* 输入框真实高度 */
  /* background-color: blue; */
  border: 10px solid rgb(255, 255, 255);
  min-height: 300px;
  padding: 20px 35px 20px;
  /* height: 200px; */
}
.quill-editor .ql-toolbar {
  background-color: white;
  border: 1px solid rgb(247, 245, 245);
  box-shadow: 2px 2px 5px 0.05px #cecccc;
}
.ql-toolbar .ql-snow {
  width: 70%;
}
.ql-container.ql-snow {
  /* 输入框样式 */
  /* width: 80%;
  margin: auto; */
  border: 1px solid rgb(247, 245, 245);
  box-shadow: 2px 2px 5px 0.05px #cecccc;
  margin-bottom: 20px;
  /* width: 80%; */
}
.quill-editor {
  line-height: normal;
}
</style>